import defaultTable from '@/components/layout/defaultTable/DefaultTable.vue'
import { faturaMixin } from '@/modules/faturas/mixins'
import util from '@/util'

export default {
  name: 'listagem-pedidos',
  props: {
    itens: { type: Array, default: () => [] },
    estaCarregando: { type: Boolean, default: false },
    colunas: { type: Array, required: true }
  },
  components: {
    'default-table': defaultTable
  },
  mixins: [faturaMixin],

  computed: {
    dados () {
      return this.itens || []
    },
    campos () {
      return this.colunas || []
    },
    carregando () {
      return this.estaCarregando
    }
  },

  methods: {
    definirClasseLinha (item, type) {
      if (util.valorVazio(item) && type === 'row-empty') {
        return 'text-center trCorTextoPadrao'
      }
      return 'trCorTextoPadrao'
    },
    onAction (id) {
      this.$emit('action', id)
    }
  }
}
